import { useEffect, useState } from "react";
import { Info } from "lucide-react";
import { PageShell } from "@/components/site/PageShell";
import { api } from "@/lib/api";
import { BRAND_PHOTOS, STOCK } from "@/lib/constants";

export default function About() {
  const [about, setAbout] = useState(null);
  useEffect(() => { api.get("/about").then((r) => setAbout(r.data.about)); }, []);
  return (
    <PageShell testId="about-page" overline="About Accelary" title="One workshop. Three disciplines." image={BRAND_PHOTOS[5]}
      intro={about?.intro}>
      {about && (
        <>
          <blockquote className="font-display text-2xl md:text-3xl font-bold text-[#020165] max-w-3xl leading-snug border-l-4 border-[#F86900] pl-6" data-testid="about-philosophy">
            “{about.philosophy}”
          </blockquote>
          <div className="mt-12 grid lg:grid-cols-5 gap-8">
            <div className="lg:col-span-3 space-y-6">
              {about.sections.map((s) => (
                <section key={s.heading} className="rounded-2xl bg-white p-6">
                  <h2 className="font-display font-bold text-xl text-[#0D141A]">{s.heading}</h2>
                  <p className="mt-2 text-[#56585E] leading-relaxed">{s.body}</p>
                </section>
              ))}
            </div>
            <div className="lg:col-span-2 grid grid-cols-2 gap-3 h-fit">
              {[BRAND_PHOTOS[6], BRAND_PHOTOS[7], ...STOCK.slice(0, 2)].map((src, i) => (
                <figure key={src} className={`relative overflow-hidden rounded-xl ${i === 0 ? "col-span-2 aspect-[16/9]" : "aspect-square"}`}>
                  <img src={src} alt="" className="h-full w-full object-cover" />
                  {i > 1 && <figcaption className="absolute bottom-1 left-1 text-[10px] bg-black/60 text-white px-2 py-0.5 rounded">Illustrative stock</figcaption>}
                </figure>
              ))}
            </div>
          </div>
          <div className="mt-10 rounded-2xl border border-dashed border-[#56585E]/40 p-5 flex gap-3 text-sm text-[#56585E]" data-testid="about-pending-facts">
            <Info className="h-5 w-5 shrink-0" />
            <div><p className="font-semibold text-[#1D1E20]">Awaiting owner confirmation</p>{about.pending.map((p) => <p key={p}>{p}</p>)}</div>
          </div>
        </>
      )}
    </PageShell>
  );
}
